import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLabAnalysis = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 41,
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20 10.5C17.243 10.5 15 12.743 15 15.5C15 18.257 17.243 20.5 20 20.5C22.757 20.5 25 18.257 25 15.5C25 12.743 22.757 10.5 20 10.5ZM20 18.5C18.346 18.5 17 17.154 17 15.5C17 13.846 18.346 12.5 20 12.5C21.654 12.5 23 13.846 23 15.5C23 17.154 21.654 18.5 20 18.5ZM29 29.5V28.5C29 24.641 25.859 21.5 22 21.5H18C14.14 21.5 11 24.641 11 28.5V29.5H13V28.5C13 25.743 15.243 23.5 18 23.5H22C24.757 23.5 27 25.743 27 28.5V29.5H29Z",
		fill: "#00B087"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1.5,
		width: 38,
		height: 38,
		rx: 15,
		stroke: "#00B087",
		strokeWidth: 2
	})]
});
export default SvgLabAnalysis;
